module.exports = __webpack_public_path__ + "img/2_hills.2864a508.jpg";